import { TooltipRenderer, Box, IconHelp } from 'braid-design-system';
import { useRef } from 'react';

type TooltipMessage = React.ComponentProps<typeof TooltipRenderer>['tooltip'];

export interface TooltipProps {
  ariaLabel: string;
  tooltipId: string;
  message: TooltipMessage;
  onTrigger: () => void;
}

// the timeout for hovers to activate tooltip messages is derived from braid's code
// https://github.com/seek-oss/braid-design-system/blob/654f5a8db7efa63ed36654bb433633b502d04974/packages/braid-design-system/src/lib/components/TooltipRenderer/TooltipRenderer.tsx#L297-L298
const TRIGGER_TOOLTIP_ACTIVE_TIMER = 250;

export const ContextualHelp = ({
  ariaLabel,
  tooltipId,
  message,
  onTrigger,
}: TooltipProps) => {
  const timer = useRef<null | NodeJS.Timeout>(null);

  const onMouseEnterHandler = () => {
    timer.current = setTimeout(() => {
      timer.current = null;
      onTrigger();
    }, TRIGGER_TOOLTIP_ACTIVE_TIMER);
  };

  const onMouseLeaveHandler = () => {
    if (timer.current) {
      clearTimeout(timer.current as NodeJS.Timeout);
      timer.current = null;
    }
  };

  return (
    <TooltipRenderer id={tooltipId} placement="top" tooltip={message}>
      {({ triggerProps }) => (
        <Box
          display="inline"
          onMouseEnter={onMouseEnterHandler}
          onMouseLeave={onMouseLeaveHandler}
          aria-label={ariaLabel}
          {...triggerProps}
        >
          <IconHelp />
        </Box>
      )}
    </TooltipRenderer>
  );
};
